/* ヘッダ固定 */
const MENU_HEIGHT = $('#top-header').height(), DURATION = 500;

$('body').css('padding-top', MENU_HEIGHT);
$('a[href^="#"]').click(function() {
    let href         = $(this).attr("href");
    let target       = $(href == "#" || href == "" ? 'html' : href);
    $('body, html').animate({scrollTop:target.offset().top-MENU_HEIGHT}, DURATION, 'swing');
});

/* アンカーへオフセットを追加してスクロール */
const url = $(location).attr('href');
if (url.indexOf("#") != -1) {
    let id = url.split("#");
    let $target = $('#' + id[id.length - 1]);
    if ($target.length) {
        $('body, html').animate({ scrollTop: $target.offset().top - MENU_HEIGHT }, DURATION, 'swing');
    }
}



// WEBPACK FOOTER //
// ./src/fixed-header.js